import PropTypes from "prop-types"
import React from "react"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import SmartLink from "../../../layout/SmartLink/SmartLink"
import { image, mapText, mapViewButton } from "./styles.module.scss"
import { InlineText } from "../../../Typography/Typography"
import { CARE_MAP_URL } from "../../../../utils/paths"
import Icon from "../../../layout/icon"
import StaticImage from "../../../StaticImage"

const mapViewButtonClickEvent = {
  name: "SEO - Filtered Directory - View Map Button Clicked",
}

const MapViewButton = ({ locationName, careProvidedParam }) => (
  <SmartLink
    to={`${CARE_MAP_URL}?location=${locationName}${careProvidedParam}`}
    clickEvent={mapViewButtonClickEvent}
    className={mapViewButton}
  >
    <StaticImage name="map_bg" className={image} loading="eager" />
    <InlineText brand useParentSize className={mapText}>
      View results on a map <Icon icon={faChevronRight} />
    </InlineText>
  </SmartLink>
)

MapViewButton.propTypes = {
  locationName: PropTypes.string.isRequired,
  careProvidedParam: PropTypes.string,
}

MapViewButton.defaultProps = {
  careProvidedParam: "",
}

export default MapViewButton
